import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import AddCircleIcon from '@mui/icons-material/AddCircle';
import { containedButtonStyle } from '@/theme';

type EmptyLogSectionsScreenProps = {
  onCreateFirstSection: () => void;
};

export const EmptyLogSectionsScreen = ({ onCreateFirstSection }: EmptyLogSectionsScreenProps) => {
  return (
    <Box
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      minHeight={300}
      gap={2}
    >
      <Button
        startIcon={<AddCircleIcon />}
        variant="contained"
        sx={containedButtonStyle}
        onClick={onCreateFirstSection}
      >
        Add New Form
      </Button>
    </Box>
  );
};
